import script from "./UserProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileCard.vue?vue&type=style&index=0&id=00300ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00300ffc"]])

export default __exports__